// extracted by mini-css-extract-plugin
module.exports = {"app-container":"app_app-container__1_VYX"};